<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="postData"
      label-position="right"
      label-width="160px"
      class="form"
    >
      <el-form-item label="等级 ID">{{ id }}</el-form-item>

      <el-form-item label="等级名称" prop="level_name">
        <el-input
          v-model="postData.level_name"
          maxlength="8"
          show-word-limit
          clearable
          placeholder="请输入等级名称"
        />
      </el-form-item>

      <el-form-item label="最小上课次数" prop="min_hours">
        <el-input
          v-model="postData.min_hours"
          type="number"
          min="1"
          placeholder="请输入最小上课次数"
        />
      </el-form-item>

      <el-form-item label="最大上课次数" prop="max_hours">
        <el-input
          v-model="postData.max_hours"
          type="number"
          min="1"
          placeholder="留空表示无上限"
        />
      </el-form-item>

      <el-form-item label="等级颜色" prop="color">
        <el-input
          v-model="postData.color"
          maxlength="16"
          clearable
          placeholder="请输入颜色，如 #77cb8a"
        />
      </el-form-item>

      <v-image-upload
        v-model="postData.icon_url"
        label="等级图标"
        prefix="student-rank-level"
        ratio="5:2"
        propName="icon_url"
        placeholder="建议上传 5:2 比例的等级标签图片"
      />

      <el-form-item>
        <el-button type="primary" :loading="isSaving" :disabled="isLoading" @click="handleSubmit">提交</el-button>
        <el-button @click="RouteConfig.studentRankLevelList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/student-rank-level';

export default {
  name: RouteConfig.studentRankLevelEdit.name,
  data: () => ({
    RouteConfig,
    id: 0,
    update_time: 0,
    isLoading: true,
    isSaving: false,
    postData: {
      level_name: '',
      min_hours: '',
      max_hours: '',
      color: '',
      icon_url: '',
    },
  }),
  computed: {
    rules() {
      return {
        level_name: [{ required: true, message: '请输入等级名称', trigger: 'change' }],
        min_hours: [{ required: true, message: '请输入最小上课次数', trigger: 'change' }],
        max_hours: [{
          validator: (rule, value, callback) => {
            if (value !== '' && +value <= 0) return callback(new Error('最大次数必须大于 0'));
            if (value !== '' && +value < +this.postData.min_hours) {
              return callback(new Error('最大次数不能小于最小次数'));
            }
            callback();
          },
          trigger: 'change',
        }],
      };
    },
  },
  methods: {
    async load() {
      this.id = +this.$route.params.id || 0;
      if (!this.id) return RouteConfig.studentRankLevelList.push();

      this.isLoading = true;
      const { isError, data } = await show(this.id);
      this.isLoading = false;
      if (isError || !data || !data.id) return RouteConfig.studentRankLevelList.push();

      this.update_time = data.update_time || 0;
      this.postData.level_name = data.level_name || '';
      this.postData.min_hours = data.min_hours || '';
      this.postData.max_hours = data.max_hours === null ? '' : data.max_hours;
      this.postData.color = data.color || '';
      this.postData.icon_url = data.icon_url || '';
    },
    async handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const { isError } = await update(this.id, {
          update_time: this.update_time,
          level_name: this.postData.level_name,
          min_hours: +this.postData.min_hours,
          max_hours: this.postData.max_hours === '' ? null : +this.postData.max_hours,
          color: this.postData.color,
          icon_url: this.postData.icon_url,
        });
        this.isSaving = false;
        if (!isError) RouteConfig.studentRankLevelList.push();
      });
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>
